// extracted by mini-css-extract-plugin
module.exports = {"MobileButton":"AddIngredientButton_MobileButton__2Yc1b","DesktopButton":"AddIngredientButton_DesktopButton__1hK8O"};